import axios from "axios";
import { getAccessToken } from "../services/cookieService";
import { handle403Redirect } from "utils/authHandlers";
import { environment } from "../environments/environment";

const HOST_URL = environment.HOST_URL;
const version = environment.GIFTHUB_API_VERSION;

export const ecomInterceptor = axios.create({
  baseURL: `${HOST_URL}/${version}`,
});

ecomInterceptor.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // ✅ Set Content-Type only if not FormData
    const isFormData = config.data instanceof FormData;
    if (!isFormData) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: handle unauthorized globally
ecomInterceptor.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("error: ", error);
    if (error.response && error.response.status === 403) {
      console.warn("Unauthorized access - token might be invalid");
      handle403Redirect();
    }
    return Promise.reject(error);
  }
);

export default ecomInterceptor;
